import Http from '@/plugins/http.js';

export default {
    // 获取部门下的子部门和组 后面的参数是指定部门范围和"Originator.OU" ,可以传空数组,但不能为null
    getChildDeptAndGroup(deptID, postParam, filterRole = false) {
        postParam = postParam || {
            ScopeUnitIds: [],
            Categories: [],
            OriginatorParses: [],
            ContainsSub: false,
            FilterRole: false,
            FilterInactive: true,
        };
        if (filterRole) {
            postParam['FilterRole'] = true;
        }
        return Http.POST(`/api/Organization/GetChildDeptAndGroup/` + deptID, postParam);
    },
    /**
     *  获取组织机构所有组（按组名去重）
     */
    getAllGroups() {
        return Http.GET(`/api/Organization/GetAllGroups`);
    },
    /**
     * 获取部门类型列表
     */
    getCategoryList() {
        return Http.GET(`/api/Organization/GetCategoryList`);
    },

    // 获取部门下的人员 /api/Organization/GetChildUsers/
    getUserByParentId(parentId) {
        return Http.GET(`/api/Organization/GetChildUsers/${parentId}`);
    },

    getUsersByCondition(
        PagingInfo = {
            PageIndex: 1,
            PageSize: 10,
        },
        SearchCondition = [],
        FilterRole = false,
        State,
        filterFieldRole
    ) {
        var str = '';
        if (filterFieldRole != undefined) {
            str = '/' + filterFieldRole;
        }
        return Http.POST(`/api/Organization/GetChildUsers/${State}${str}`, {
            PagingInfo,
            SearchCondition,
            FilterRole,
        });
    },
    // 获取部门和人员
    getChildDeptAndUser(parentId) {
        return Http.GET(`/api/Organization/GetChildDeptAndUser/${parentId}`);
    },
    // 获取角色
    getRoleList() {
        return Http.GET('/api/Organization/GetRoleList');
    },

    //搜索人员部门
    selectUnit(keyWord, maxCount = 10, onlyOrgUnit = false) {
        return Http.GET(`/api/Organization/SelectUnit/${keyWord}/${maxCount}/${onlyOrgUnit}`);
    },
    //根据id获取部门信息
    getDeptInfoById(deptId) {
        return Http.GET('/api/Organization/GetDeptInfo/' + (deptId ? deptId : ''));
    },
    isDepartmentSole(parentId, name, objectId) {
        return Http.GET(
            'api/Organization/IsDeptSole/' +
                parentId +
                '/' +
                encodeURIComponent(name) +
                '/' +
                objectId
        );
    },
    // 添加部门
    addDepartment(deptObj) {
        return Http.POST('/api/Organization/AddDept', deptObj);
    },
    // 更新部门信息
    updateDepartment(deptObj) {
        return Http.POST('/api/Organization/UpdateDept', deptObj);
    },

    //根据id获取组信息
    getGroupInfoById(groupId) {
        return Http.GET('/api/Organization/GetGroupInfo/' + (groupId ? groupId : ''));
    },
    isGroupSole(parentId, name, objectId) {
        return Http.GET('api/Organization/IsGroupSole/' + parentId + '/' + name + '/' + objectId);
    },
    // 添加部门
    addGroup(groupObj) {
        return Http.POST('/api/Organization/AddGroup', groupObj);
    },
    // 更新部门信息
    updateGroup(groupObj) {
        return Http.POST('/api/Organization/UpdateGroup', groupObj);
    },

    //根据id获取组信息
    getUserInfoById(userId) {
        return Http.GET('/api/Organization/GetUserById/' + userId);
    },
    // 添加人员
    addUser(userObj) {
        return Http.POST('/api/Organization/AddUser', userObj);
    },
    // 更新人员
    updateUser(userObj) {
        return Http.POST('/api/Organization/UpdateUserInfo', userObj);
    },
    //人员code唯一性验证
    isUserSole(userCode, objectId) {
        return Http.GET('api/Organization/IsUserSole/' + userCode + '/' + objectId);
    },
    // 删除部门、组、人员
    deleteUnitById(id) {
        return Http.GET('api/Organization/DeleteUnitById/' + id);
    },
    // 禁用人员
    inActiveUser(userId) {
        return Http.GET('api/Organization/InActiveUser/' + userId);
    },
    // 获取人员组及角色信息
    getUserRoleAndGroupById(userObj) {
        return Http.GET(`api/Organization/GetUserRoleAndGroupById/${userObj}`);
    },
    getChildDepts(id) {
        return Http.GET(`api/Organization/GetChildDepts/${id}`);
    },
    getChildDeptAndGroupWithAcl(AclId, unitId) {
        let str = unitId ? AclId + '/' + unitId : AclId + '/';
        return Http.POST(`api/Organization/GetChildDeptAndGroupWithAcl/${str}`, {
            FilterGroup: true,
            FilterRole: true,
        });
    },
    GetChildUsersWithAcl(AclId, params, activeState, filterFieldRole) {
        let str = activeState ? AclId + '/' + activeState : AclId + '/';
        str = activeState && filterFieldRole != undefined ? str + '/' + filterFieldRole : str;
        return Http.POST(`/api/Organization/GetChildUsersWithAcl/${str}`, params);
    },
    getUserFullName(ObjectID) {
        return Http.GET(`api/Organization/GetUserFullName/${ObjectID}`);
    },
};
